import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Product } from "../../../models/product.ts";
import { CategoryType } from "../../../models/category-type.ts";
import {
  getProducts,
  getProductsByCategory,
} from "../../../Services/product.service.ts";
import CardRating from "../../product/CardRating.tsx";
import BarSpinner from "../../Loader/BarSpinner.tsx";
import NoProductFound from "../../NoProductFound/NoProductFound.tsx";

const TABS = ["ALL", "READY TO WEAR", "UNSTITCHED", "FORMAL WEAR"] as const;

const saleAmount = (product: Product) =>
  typeof product.sale === "number" ? product.sale : 0;

const priceLabel = (product: Product) => {
  const sale = saleAmount(product);
  if (sale > 0) {
    return Math.round(product.price * (1 - sale / 100));
  }
  return product.price;
};

const ProductCard = ({ product }: { product: Product }) => {
  const sale = saleAmount(product);
  return (
    <Link className="card" to={`/product/${product.id}`} state={{ product }}>
      <div className="ph">
        {product.isOutOfStock && <span className="tag">Sold Out</span>}
        {!product.isOutOfStock && sale > 0 && (
          <span className="tag">-{sale}%</span>
        )}
        <img src={product.images.front} alt={product.name} />
        {product.images.back && (
          <img className="h" src={product.images.back} alt="" />
        )}
      </div>
      <h3>{product.name}</h3>
      <div className="p">
        Rs {priceLabel(product).toLocaleString()}
        {sale > 0 && <s>Rs {product.price.toLocaleString()}</s>}
        <CardRating average={product.ratingAverage} count={product.ratingCount} />
      </div>
    </Link>
  );
};

const Trendy = () => {
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState<(typeof TABS)[number]>("ALL");
  const [allProducts, setAllProducts] = useState<Product[]>([]);
  const [filteredProducts, setFilteredProducts] = useState<Product[]>([]);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      const result = await getProducts();
      if (result.success) {
        setAllProducts(result.data || []);
      }
      setLoading(false);
    };
    fetchData();
  }, []);

  const handleTabClick = async (tab: (typeof TABS)[number]) => {
    setActiveTab(tab);
    if (tab === "ALL") return;
    setLoading(true);
    const result = await getProductsByCategory(tab as CategoryType);
    if (result.success) {
      setFilteredProducts(result.data || []);
    }
    setLoading(false);
  };

  const products =
    activeTab === "ALL" ? allProducts.slice(0, 12) : filteredProducts.slice(0, 12);

  return (
    <section className="sec" id="best">
      <h2>
        Best Sellers & Trending Now <Link to="/shop">View all</Link>
      </h2>
      <div className="tabs">
        {TABS.map((tab) => (
          <button
            key={tab}
            className={activeTab === tab ? "on" : ""}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </button>
        ))}
      </div>
      {loading ? (
        <div className="loader-wrap">
          <BarSpinner />
        </div>
      ) : products.length > 0 ? (
        <div className="grid">
          {products.map((product) => (
            <ProductCard key={product.id} product={product} />
          ))}
        </div>
      ) : (
        <NoProductFound />
      )}
    </section>
  );
};

export default Trendy;
